import React from 'react';
import { AppLayout } from '@/components/layout/app-layout';
import { TransactionReviewQueue } from '@/components/review/TransactionReviewQueue';
import { useActiveMandate } from '@/hooks/use-active-mandate';
import { Card, CardContent } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

const ReviewQueue: React.FC = () => {
  const { mandate } = useActiveMandate();

  if (!mandate) {
    return (
      <AppLayout>
        <Card>
          <CardContent className="p-6">
            <div className="flex items-center gap-2 text-orange-600">
              <AlertCircle className="h-5 w-5" />
              <p>Bitte wählen Sie ein Mandat aus.</p>
            </div>
          </CardContent>
        </Card>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-brand-primary">Review Queue</h1>
          <p className="text-brand-text-secondary mt-2">
            Überprüfen Sie AI-klassifizierte Transaktionen
          </p>
        </div>
        <TransactionReviewQueue mandateId={mandate.id} />
      </div>
    </AppLayout>
  );
};

export default ReviewQueue;
